"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; } var _class;

var _chunk7ZPN562Ocjs = require('./chunk-7ZPN562O.cjs');


var _chunkC3OQGEQIcjs = require('./chunk-C3OQGEQI.cjs');


var _chunkWF6EZ2CWcjs = require('./chunk-WF6EZ2CW.cjs');


var _chunkVJSHCTQ7cjs = require('./chunk-VJSHCTQ7.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');


var _chunkQBYZPWDOcjs = require('./chunk-QBYZPWDO.cjs');

// src/contracts/dex/v2_1/pool/BasePoolV2_1.ts



var _ton = require('@ton/ton');
var BasePoolV2_1 = (_class = class _BasePoolV2_1 extends _chunkWF6EZ2CWcjs.JettonMinter {
  static __initStatic() {this.version = _chunkNE5AG7IWcjs.DEX_VERSION.v2_1}
  static __initStatic2() {this.gasConstants = {
    collectFees: _ton.toNano.call(void 0, "0.4"),
    burn: _ton.toNano.call(void 0, "0.8")
  }}
  
  constructor(address, { gasConstants, ...options } = {}) {
    super(address, options);
    this.gasConstants = {
      ..._BasePoolV2_1.gasConstants,
      ...gasConstants
    };
  }
  async createCollectFeesBody(params) {
    return _ton.beginCell.call(void 0, ).storeUint(_chunkC3OQGEQIcjs.DEX_OP_CODES.COLLECT_FEES, 32).storeUint(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _ => _.queryId]), () => ( 0)), 64).endCell();
  }
  async getCollectFeeTxParams(provider, params) {
    const to = this.address;
    const body = await this.createCollectFeesBody({
      queryId: _optionalChain([params, 'optionalAccess', _2 => _2.queryId])
    });
    const value = BigInt(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _3 => _3.gasAmount]), () => ( this.gasConstants.collectFees)));
    return { to, value, body };
  }
  async sendCollectFees(provider, via, params) {
    const txParams = await this.getCollectFeeTxParams(provider, params);
    return via.send(txParams);
  }
  async createBurnBody(params) {
    return _ton.beginCell.call(void 0, ).storeUint(_chunkC3OQGEQIcjs.DEX_OP_CODES.BURN, 32).storeUint(_nullishCoalesce(_optionalChain([params, 'optionalAccess', _4 => _4.queryId]), () => ( 0)), 64).storeCoins(BigInt(params.amount)).storeAddress(null).storeMaybeRef(params.dexCustomPayload).endCell();
  }
  async getBurnTxParams(provider, params) {
    const [to, body] = await Promise.all([
      this.getWalletAddress(provider, params.userWalletAddress),
      this.createBurnBody({
        amount: params.amount,
        dexCustomPayload: params.dexCustomPayload,
        queryId: params.queryId
      })
    ]);
    const value = BigInt(_nullishCoalesce(params.gasAmount, () => ( this.gasConstants.burn)));
    return { to, value, body };
  }
  async sendBurn(provider, via, params) {
    const txParams = await this.getBurnTxParams(provider, params);
    return via.send(txParams);
  }
  async getPoolType(provider) {
    const result = await provider.get("get_pool_type", []);
    return result.stack.readString();
  }
  async getLpAccountAddress(provider, params) {
    const result = await provider.get("get_lp_account_address", [
      {
        type: "slice",
        cell: _ton.beginCell.call(void 0, ).storeAddress(_chunkQBYZPWDOcjs.toAddress.call(void 0, params.ownerAddress)).endCell()
      }
    ]);
    return result.stack.readAddress();
  }
  async getLpAccount(provider, params) {
    const lpAccountAddress = await this.getLpAccountAddress(provider, params);
    return _chunk7ZPN562Ocjs.LpAccountV2_1.create(lpAccountAddress);
  }
  async getJettonWallet(provider, params) {
    const jettonWalletAddress = await this.getWalletAddress(
      provider,
      params.ownerAddress
    );
    return _chunkVJSHCTQ7cjs.JettonWallet.create(jettonWalletAddress);
  }
  async getPoolData(provider) {
    const data = await this.implGetPoolData(provider);
    return data.commonPoolData;
  }
  async implGetPoolData(provider) {
    const result = await provider.get("get_pool_data", []);
    return {
      commonPoolData: {
        isLocked: result.stack.readBoolean(),
        routerAddress: result.stack.readAddress(),
        totalSupplyLP: result.stack.readBigNumber(),
        reserve0: result.stack.readBigNumber(),
        reserve1: result.stack.readBigNumber(),
        token0WalletAddress: result.stack.readAddress(),
        token1WalletAddress: result.stack.readAddress(),
        lpFee: result.stack.readBigNumber(),
        protocolFee: result.stack.readBigNumber(),
        protocolFeeAddress: result.stack.readAddressOpt(),
        collectedToken0ProtocolFee: result.stack.readBigNumber(),
        collectedToken1ProtocolFee: result.stack.readBigNumber()
      },
      stack: result.stack
    };
  }
}, _class.__initStatic(), _class.__initStatic2(), _class);



exports.BasePoolV2_1 = BasePoolV2_1;
//# sourceMappingURL=chunk-HJFO65XK.cjs.map